export default function GallerySection({ images = [] }) {
  if (!images.length) return null;
  return (
    <section className="border-t border-line/70" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {images.slice(0, 4).map((src, i) => (
            <div key={i} className="aspect-square rounded-xl overflow-hidden border border-line/60 group">
              <img
                src={src}
                alt=""
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
